import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { IHeatmap } from './heatmap.service.model';

enum STATE {
  FRESH,
  LOADING,
  LOADED,
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  rootScopeData: RootScopeDeclare;

  private _heatMapData: any = {};
  private _heatMapDataSource = new Subject<IHeatmap>();
  public heatMapDataSource = this._heatMapDataSource.asObservable();

  // state
  private _stateHeatMapData: STATE = STATE.FRESH;
  private _loadedHeatMapDataFacilityId: string = '';

  constructor(
    private httpClient: HttpClient,
    private rootScopeService: RootScopeService,
    private httpHeaderService: HttpHeadersService,
    private _facilityService: FacilityService
  ) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  createManagerAccount(dataInput: any): Observable<any> {
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/register/manager', dataInput, { headers });
  }

  // getHeatMapData(facilityId): Observable<any> {
  //   const d = new Date();
  //   const offset = d.getTimezoneOffset();
  //   const params = new HttpParams()
  //     .set('facilityId', facilityId)
  //     .set('offset', offset.toString())
  //     .set('v', Math.random().toString());
  //   const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
  //   return this.httpClient.get(environment.servicePath + '/heatmap', { headers, params });
  // }

  getHeatMapData() {
    const facilityId = this._facilityService.selectedFacilityId();
    // if (facilityId !== this._loadedHeatMapDataFacilityId) {
      const d = new Date();
      const offset = d.getTimezoneOffset();
      const params = new HttpParams()
        .set('facilityId', facilityId)
        .set('offset', offset.toString())
        .set('v', Math.random().toString());

      const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
      this.httpClient.get(`${environment.servicePath}/heatmap`, { headers, params }).subscribe(
        (res: any) => {
          this._heatMapData = this.processHeatmapResponse(res);
          // stream
          this._heatMapDataSource.next(this._heatMapData);
        },
        (err: any) => {
          console.error('API failed.')
        },
        () => {
          this._loadedHeatMapDataFacilityId = facilityId;
        }
      );
    // } else {
    //   this._heatMapDataSource.next(this._heatMapData);
    // } 
  }

  saveHeatMapGridInfo(dataInput: any): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/heatmap/grid', dataInput, { headers });
  }

  getDashboardTileData(facilityId: string, currentDate: string): Observable<any> {
    const params = new HttpParams()
      .set('facilityId', facilityId)
      .set('currDay', currentDate)
      .set('v', Math.random().toString());
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(environment.servicePath + '/maintenance/tiles', { headers, params });
  }

  getPendingHeatMapAssets(facilityId: string): Observable<any> {
    const params = new HttpParams().set('facilityId', facilityId).set('v', Math.random().toString());
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(environment.servicePath + '/heatmap/pendingEquipments', { headers, params });
  }

  addEquipment(dataInput: any): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/heatmap/add_equipment', dataInput, { headers });
  }

  moveEquipment(dataInput: any): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/heatmap/move_equipment', dataInput, { headers });
  }

  deleteEquipment(dataInput: any): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/heatmap/delete_equipment', dataInput, { headers });
  }

  deleteHeatMapGridInfo(dataInput: any): Observable<any> {
    //  let params = new HttpParams().set('facilityId', dataInput.facilityId).set('floorId', dataInput.floorId).set('v', Math.random().toString());
    let params = new HttpParams();
    params = params.set('facilityId', dataInput.facilityId);
    params = params.set('floorId', dataInput.floorId);
    params = params.set('v', Math.random().toString());

    if (dataInput.rowId) {
      params = params.set('rowId', dataInput.rowId);
    }

    if (dataInput.colId) {
      params = params.set('colId', dataInput.colId);
    }
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.delete(environment.servicePath + '/heatmap/grid', { headers, params });
  }

  enableFacilitySummaryEmail(facilityId: string): Observable<any> {
    const inputJson: any = {};
    inputJson.facilityId = facilityId;
    inputJson.emailSetting = 'true';
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/statistics/update_stat_email', inputJson, { headers });
  }

  enrollReleaseNotesEmail(facilityId: string): Observable<any> {
    const inputJson: any = {};
    inputJson.facilityId = facilityId;
    inputJson.releaseNotesEmail = 'true';
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/lfasset_facility/email_setting', inputJson, { headers });
  }

  askHaloMediaQuestion(inputJson: any): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/maintenance/sendHaloMediaHelpEmail', inputJson, {
      headers,
    });
  }

  getStatsUsageData(facilityId: string, timezoneOffset: string): Observable<any> {
    const params = new HttpParams()
      .set('facilityId', facilityId)
      .set('offset', timezoneOffset)
      .set('v', Math.random().toString());
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(environment.servicePath + '/statistics/dashboard_summary', { headers, params });
  }

  getStatsUsageDataLynx(facilityId: string): Observable<any> {
    const params = new HttpParams()
      .set('facilityId', facilityId);
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(environment.servicePath + '/statistics/dashboard_summary/lynx_peak_data', { headers, params });
  }

  getCalendarData(facilityId: string, timezone: string): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(
      environment.servicePath + '/maintenance/calendar?facilityId=' + facilityId + '&timezone=' + timezone,
      { headers }
    );
  }

  disableAnnouncementPopup(data: any): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/lfasset_facility/user_preference', data, { headers });
  }

  private processHeatmapResponse(data: any) {
    if(!data) return data;
    
    data.totalIdleCount = Number(data.totalIdleCount),
    data.showIdlePopHeatMap = data.showIdlePopHeatMap === 'true',
    data.rotationCompleteHeatMap = data.rotationCompleteHeatMap === 'true',
    data.floors?.forEach((f: any) => {
      f.floorId = Number(f.floorId);
      f.floorDetails?.forEach((d: any) => {
        d.rowId = Number(d.rowId);
        d.columns?.forEach((c: any) => {
          c.activityId = Number(c.activityId);
          c.columnId = Number(c.columnId);
        });
      });
    });
    return data;
  }
}
